import { IState } from 'legacy/lut/store'
import { ILookupState } from 'legacy/lut/store/state'

export const selectBusinessProfileState = (state: IState & ILookupState) => ({
  selectedPartner: state.lookupOld.masterDataWidget.selectedPartner,
  countries: state.lookupOld.references.countries,
})
